// Tymczasowe obrazki testowe powiązane z działem forum.
// Używane na liście postów oraz na stronie dyskusji.
export const TAG_FALLBACK_IMAGES = {
  'dzialamy-biznes': 'https://picsum.photos/id/48/400/200',
  'biznes': 'https://picsum.photos/id/48/400/200',
  'general': 'https://picsum.photos/id/28/400/200',
  'pomoc': 'https://picsum.photos/id/146/400/200',
  'oferta': 'https://picsum.photos/id/48/400/200',
  'spolecznosc': 'https://picsum.photos/id/152/400/200',
  'arena': 'https://picsum.photos/id/180/400/200',
  'ogloszenia': 'https://picsum.photos/id/237/400/200',
  'ogloszenia-administracji': 'https://picsum.photos/id/237/400/200',
  'nasze-hobby': 'https://picsum.photos/id/152/400/200',
  'sprawdzmy-to': 'https://picsum.photos/id/180/400/200',
  'sprawy-do-wyjasnienia': 'https://picsum.photos/id/208/400/200',
  'potrzebuje-pomocy': 'https://picsum.photos/id/146/400/200',
  'oferuje': 'https://picsum.photos/id/48/400/200',
  'poszukuje': 'https://picsum.photos/id/48/400/200',
  'kupie': 'https://picsum.photos/id/48/400/200',
  'sprzedam': 'https://picsum.photos/id/48/400/200',
  'mam-pomysl': 'https://picsum.photos/id/29/400/200',
  'szukam-pracy': 'https://picsum.photos/id/48/400/200',
  'szukam-pracownika': 'https://picsum.photos/id/48/400/200',
  'szukam-wspolnika': 'https://picsum.photos/id/48/400/200',
  'szukam-inwestora': 'https://picsum.photos/id/48/400/200',
  'wielki-atlas-wybrancow-narodu': 'https://picsum.photos/id/237/400/200',
  'niewygodne': 'https://picsum.photos/id/208/400/200',
  'budujemy-pakt21': 'https://picsum.photos/id/20/400/200',
};

export function tagFallbackImageUrl(tagSlug, width = 400, height = 200) {
  const url = TAG_FALLBACK_IMAGES[tagSlug];
  if (!url) return `https://picsum.photos/id/28/${width}/${height}`;
  return url.replace(/\/\d+\/\d+$/, `/${width}/${height}`);
}
